export default __webpack_public_path__ + "static/project-t-5cc7ac5d4d43e6f519c7206b0f4c7c8f.jpg";